var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconVisibilityOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.583 7.783h0.2q1.733 0 3 1.267t1.267 3v0.267zM9.45 8.917q-0.8 1.6-0.8 3.133 0 2.933 2.1 5.033t5.033 2.1q1.533 0 3.133-0.8l-2.2-2.2q-0.533 0.133-0.933 0.133-1.733 0-3-1.267t-1.267-3q0-0.4 0.133-0.933zM1.583 1.050l1.8-1.8 25.2 25.2-1.8 1.8q-0.333-0.333-2.1-2.067t-2.7-2.667q-2.867 1.2-6.2 1.2-5.267 0-9.533-2.933t-6.133-7.733q0.733-1.733 2.3-3.833t3.033-3.233q-0.8-0.8-2.233-2.267t-1.633-1.667zM15.783 4.917q-1.333 0-2.6 0.533l-3.067-3.067q2.6-1 5.667-1 5.267 0 9.5 2.933t6.1 7.733q-1.6 3.933-4.867 6.733l-4.133-4.133q0.533-1.267 0.533-2.6 0-2.933-2.1-5.033t-5.033-2.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVisibilityOff);
export default __webpack_public_path__ + "static/media/icon-visibility-off.ab13e92b67e1b7ed952c3eff8d27585b.svg";
export { ForwardRef as ReactComponent };